import React, { useLayoutEffect, useRef } from 'react';
import c from './tab.module.scss';
import { Badge } from '@monash/portal-react';

const Tab = ({
  tab,
  onKeyUp,
  tabIndex,
  onClick,
  menuIndex,
  newCount,
  setWidths,
}) => {
  const ref = useRef(null);
  const tabName = tab?.name || '';

  useLayoutEffect(() => {
    if (ref.current) {
      const width = ref.current.getBoundingClientRect().width;

      setWidths((widths) => {
        const newWidths = [...widths];
        newWidths[menuIndex] = width;
        return newWidths;
      });
    }
  }, [ref]);

  return (
    <li ref={ref} data-menu-index={menuIndex}>
      {/* Note: ML-4487: <button> node has to be the first child here */}
      <button
        type="button"
        className={c.tab}
        onClick={onClick}
        onKeyUp={onKeyUp}
        tabIndex={tabIndex}
        aria-label={`Navigate to ${tabName} page.`}
        data-menu-index={menuIndex}
        data-tracking-event={'topnav-page-tab-' + tabName.toLowerCase()}
      >
        {tabName}
      </button>
      {Boolean(newCount) && (
        <Badge
          status="information"
          count={newCount}
          offset={[-4, 3]}
          role="none"
        />
      )}
    </li>
  );
};

export default Tab;
